
import BButton from 'JS/components/BButton.vue';
import ButtonSpinner from 'JS/components/ButtonSpinner.vue';
import { computed, defineComponent } from 'vue';
import { useOrderStore } from '../../state/order';
import { WorkOrderType } from '../../types/session';

export default defineComponent({
	components: {
		BButton,
		ButtonSpinner,
	},
	setup () {
		const orderStore = useOrderStore();
		const appointmentType = computed(() => orderStore.session?.type === WorkOrderType.ServiceOnly ? 'Service' : 'Installation');

		return {
			orderStore,
			appointmentType,
		};
	}
});
